import { api } from './authService'; // Importamos la instancia configurada de Axios

/**
 * @description Obtiene la lista de todos los proyectos desde la API.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con la lista de proyectos.
 */
const getProjects = (params = {}) => {
  return api.get('/projects', { params });
};

/**
 * @description Obtiene el listado completo de proyectos (id + nombre), sin paginar.
 * Pensado para poblar selects/dropdowns — a diferencia de getProjects(), no está
 * sujeto al límite de página (máx. 100) del endpoint tabular, por lo que no se rompe
 * a medida que crece la cantidad de proyectos.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con { data: [{project_id, name}] }.
 */
const getProjectsLookup = () => {
  return api.get('/projects/lookup');
};

/**
 * @description Envía los datos de un nuevo proyecto a la API para su creación.
 * @param {object} projectData Los datos del proyecto a crear.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con el proyecto creado.
 */
const createProject = (projectData) => {
  return api.post('/projects', projectData);
};

/**
 * @description Actualiza un proyecto existente en la API.
 * @param {number | string} project_id El ID del proyecto a actualizar.
 * @param {object} projectData Los nuevos datos para el proyecto.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API con el proyecto actualizado.
 */
const updateProject = (project_id, projectData) => {
  return api.patch(`/projects/${project_id}`, projectData);
};

/**
 * @description Elimina un proyecto existente de la API.
 * @param {number | string} project_id El ID del proyecto a eliminar.
 * @returns {Promise<import('axios').AxiosResponse>} La respuesta de la API.
 */
const deleteProject = (project_id) => {
  return api.delete(`/projects/${project_id}`);
};

const projectService = {
  getProjects,
  getProjectsLookup,
  createProject,
  updateProject,
  deleteProject,
};

export default projectService;